<template>
  <b-card
    :id="alias"
    :title="$t('label_reports_genderGap_indicatorStatus_title')"
    class="gauge-container"
    :style="{ height: height }"
  />
</template>

<script>
import { ChartGauge } from "@/utils/ChartGauge";
import { mapGetters } from "vuex";

export default {
  name: "CardChartGaugeConsolidated",
  props: {
    pillarId: {
      default: "",
    },
    indicatorId: {
      default: "",
    },
    alias: {
      default: "",
    },
    height: {
      type: String,
      default: "auto",
    },
  },
  data: function () {
    return {
      indicator: {},
    };
  },
  watch: {
    alias: function (newVal, oldVal) {
      var svg = this.$d3.select("#" + oldVal);
      svg.selectAll(".gauge").remove();
      setTimeout(() => {
        this.updateGauge();
      }, 200);
    },
  },
  methods: {
    updateGauge() {
      this.indicator = this.getIndicatorDataConsolidated(
        this.pillarId,
        this.indicatorId
      );
      if (this.indicator) {
        this.createGauge(this.indicator);
      }
    },
    createGauge(indicator) {
      var tempRanges = indicator.ranges;
      var rangez = [
        tempRanges.negMin1 === "Infinity"
          ? tempRanges.negMax1 * 1.2
          : tempRanges.negMin1,
        tempRanges.negMax1,
        tempRanges.interMin1,
        tempRanges.interMax1,
        tempRanges.posMin1,
        tempRanges.posMax1,
        tempRanges.interMin2,
        tempRanges.interMax2,
        tempRanges.negMin2,
        tempRanges.negMax2 === "Infinity"
          ? tempRanges.negMin2 * 1.2
          : tempRanges.negMax2,
      ];
      var rangezDescending = rangez.slice().sort(this.$d3.descending);
      var rangezAscending = rangez.slice().sort(this.$d3.ascending);
      var min = Math.min(
        rangezAscending[0],
        indicator.markers[0],
        indicator.ideals[0]
      );
      var max = Math.max(
        rangezDescending[0],
        indicator.markers[0],
        indicator.ideals[0]
      );
      var config = {
        label: indicator.acronym,
        min: Math.round(min * 100) / 100, // indicator.negMin1,
        max: Math.round(max * 100) / 100, // indicator.negMax2,
        minorTicks: 10,
        majorTicks: 10,
        radius: 1,
      };
      config.redZones = [
        { from: config.min, to: indicator.ranges.negMax1 },
        { from: indicator.ranges.negMin1, to: config.max },
      ];
      config.yellowZones = [
        { from: indicator.ranges.interMin1, to: indicator.ranges.interMax1 },
        { from: indicator.ranges.interMin2, to: indicator.ranges.interMax2 },
      ];
      config.greenZones = [
        { from: indicator.ranges.posMin1, to: indicator.ranges.posMax1 },
      ];
      this.gauges = new ChartGauge(config, this.alias);
      this.gauges.setHasErrorOnValueFormula(indicator.errorOnValueFormula);
      this.gauges.render();
      this.gauges.redraw(indicator.value);
    },
  },
  computed: mapGetters(["getIndicatorDataConsolidated"]),
  mounted() {
    // This let update the graphic when the language change
    this.unsubscribe = this.$store.subscribe((mutation) => {
      switch (mutation.type) {
        case "SET_LANG":
          console.log("Update Gauge!!!");
          var svg = this.$d3.select(".gauge-container");
          svg.selectAll(".gauge").remove();
          this.updateGauge();

          break;
      }
    });

    this.updateGauge();
  },
  beforeDestroy() {
    console.log("Destroy Gauge!!!");
    this.unsubscribe();
  },
};
</script>
